import { useEffect, useState } from "react";

function getTodayLocal() {
  // en-CA gives YYYY-MM-DD in local time
  return new Date().toLocaleDateString("en-CA");
}

export default function BuggyBucks({ bug }) {
  const [buggyBucks, setBuggyBucks] = useState(0);
  const [earned, setEarned] = useState(0);

  //load stored values once after mount
  useEffect(() => {
    const storedBucks = parseInt(localStorage.getItem("buggyBucks") || "0");
    setBuggyBucks(storedBucks);
  }, []);

  useEffect(() => {
    if (!bug?.bugginess) {
      setEarned(0);
      return;
    }

    //check today's date. if bug has already been revealed today, do not give buggy bucks again
    const today = getTodayLocal();
    const lastDate = localStorage.getItem("buggyDate");

    //calculate earned buggy bucks based on the bug's bugginess
    const newEarned = parseInt(bug.bugginess.split("/")[0] || "0") || 0;
    setEarned(newEarned);

    if (lastDate === today) return;

    //use functional state update to ensure fresh value
    setBuggyBucks((prev) => {
      const newTotal = prev + newEarned;
      localStorage.setItem("buggyBucks", newTotal.toString());
      localStorage.setItem("buggyDate", today);
      return newTotal;
    });
  }, [bug?.id, bug?.bugginess]);

  function redeemSnack() {
    if (buggyBucks >= 20) {
      const newTotal = buggyBucks - 20;
      setBuggyBucks(newTotal);
      localStorage.setItem("buggyBucks", newTotal);
      alert(
        "snack redeemed. please screenshot this receipt and show buggy. enjoy your treat."
      );
    } else {
      alert("not enough buggy bucks! You need 20.");
    }
  }

  return (
    <div className="flex flex-col items-center gap-3  bg-pink-100 rounded-2xl p-4 shadow-md w-64">
      <h2 className="text-lg font-bold text-gray-800">buggy bucks</h2>
      <p className="text-gray-700 text-center">
        you've earned <span className="font-semibold">{earned}</span> buggy
        bucks from today’s bug! once you collect 20, you can redeem them for a
        free snack :)
      </p>
      <p className="text-gray-800 font-semibold">
        current balance: {buggyBucks}
      </p>
      <button
        disabled={buggyBucks < 20}
        onClick={redeemSnack}
        className="bg-purple-300 text-gray-900 px-4 py-2 rounded-lg shadow transition"
      >
        redeem buggy bucks
      </button>
    </div>
  );
}
